<div class="sticky layout-topbar">
  <a class="logo" *ngIf="!jeRegos">
    <img
      alt="kodit-logo"
      class="logo-image"
      id="app-logo"
      src="/assets/core-ui/images/ek-blue-black.svg"
    />
  </a>
  <div class="topbar-wrapper">
    <div class="layout-topbar p-p-0">
      <div class="topbar-left" style="border-left: 1px solid #eaecf0">
        <img
          alt="kodit-logo"
          class="mobile-logo"
          id="logo-mobile"
          src="/assets/core-ui/images/eKompanija_logo_h_siva.png"
        />


        <!-- Firma / firme -->
        <div *ngIf="korisnikTenantAccesses$ | async as availableTenants">
          <kodit-tenant-name
            *ngIf="availableTenants.korisnikTenantAccesses.length === 1"
            [currentTenant]="availableTenants.korisnikTenantAccesses[0]"
          ></kodit-tenant-name>
          <kodit-korisnik-tenant-dropdown
            *ngIf="availableTenants.korisnikTenantAccesses.length > 1"
            [availableTenants]="availableTenants"
          ></kodit-korisnik-tenant-dropdown>
        </div>
      </div>
      <div class="topbar-right">
        <ul class="topbar-menu">
          <!-- Profile -->
          <li
            [ngClass]="{
              'active-menuitem fadeInDown': topbarUserMenuActive
            }"
            class="profile-item p-ml-3"
            *ngIf="!jeRegos"

          >
            <a
              (click)="openProfileSidebar()"
              class="p-d-flex p-ai-center p-jc-center"
              tabindex="0"
            >
              <div
                class="profile-image"
                height="50"
                id="avatar-initials"
                width="50"
              ></div>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: start;
                "
              >
                <span
                  style="line-height: 1.3; font-size: 14px"
                  class="profile-name"
                >{{ name }}</span
                >
                <span
                  style="line-height: 1; font-size: 10px; color: gray"
                  class=""
                >{{ email }}</span
                >
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
